<template>
  <div class="person-info" :class="!isPC ? 'm-person-info' : ''">
    <div class="user-icon">
      <img :src="productInfo._logo" alt="">
    </div>
    <div :class="!isPC ? 'm-place-info' : ''">
      <div class="place-info-wrapper" :class="!isPC ? 'm-place-info-wrapper' : ''">
        <img :src="productInfo._flag" alt="">
        <span class="place-info" :class="popInKr ? 'in-kr-color' : ''">
          <span>{{ currentLang === 'en' ? 'Country' : '国家' }}: {{ productInfo.countryRegion }}</span><br />
          <span>{{ currentLang === 'en' ? 'Region/City' : '地区/城市' }}: {{ productInfo.provinceCity }}</span>
        </span>
      </div>
      <p class="info-item" :class="popInKr ? 'in-kr-color' : ''">{{ currentLang === 'en' ? 'Name of creator' : '主创者姓名'
        }}:
        {{ productInfo.creatorName }}</p>
      <p class="info-item" :class="popInKr ? 'in-kr-color' : ''">{{ currentLang === 'en' ? 'School' : '学校' }}:
        {{ productInfo.school }}</p>
    </div>
    <div v-if="productInfo._coImgs && productInfo._coImgs.length > 0" class="co-wroker"
      :class="popInKr ? 'in-kr-color' : ''">
      <p class="co-title">{{ currentLang === 'en' ? 'Collaborator' : '合作者' }}</p>
      <div v-for="(item, index) of productInfo._coImgs" :key="index" class="co-item">
        <img :src="item.url" alt="">
        <span class="co-info">
          <span>{{ currentLang === 'en' ? 'Name' : '姓名' }}: {{ item.name }}</span>
        </span>
      </div>
    </div>

    <!-- <div class="station-info">
      <div class="station-num" :class="popInKr ? 'in-kr-color' : ''">{{ currentLang === 'en' ? 'Exhibition Number' :
        '展位号'
        }}: {{ productInfo.boothNo }}</div>
    </div> -->
    <div class="button-group">
      <!-- <div class="ranking-wrapper">
        <span @click="openRank">
          <img src="../assets/web/ranking.svg" alt="">
        </span>
        <p :class="popInKr ? 'in-kr-color' : ''">{{ currentLang === 'en' ? 'Ranking List' : '排行榜' }}</p>
      </div>
      <div class="ranking-wrapper" @click="clickLike">
        <span>
          <img src="../assets/web/like.svg" alt="">
        </span>
        <p :class="popInKr ? 'in-kr-color' : ''">{{ currentLang === 'en' ? 'Like' : '为他点赞' }}</p>
      </div>
      <span v-if="!isPC" class="share-items"></span>
      <div class="total-like">{{ currentLang === 'en' ? 'Rocket Speed' : '火箭速度' }}: {{ totalLikeNum || 0 }}</div> -->
      <div v-if="isPC" class="share-wrapper"><span class="share-items"></span></div>
    </div>
    <!-- <div v-if="showRocket" class="rocket-wrapper">
      <img src="../assets/web/rocket.gif" alt="">
    </div>
    <div v-else class="rocket-wrapper-img">
      <img src="../assets/web/rocket_1.png" alt="">
    </div> -->
    <!-- rank wrapper -->
    <div v-if="showRank" class="rank-wrapper">
      <span class="rank-close" @click="closeRank"><img src="../assets/close.png" alt=""></span>
      <Rank :popInKr="true" />
    </div>
  </div>
</template>

<script>
import Rank from '@/common/Rank'
import axios from 'axios'
export default {
  name: 'PersonalInfo',
  props: ['popInKr', 'productInfo'],
  components: { Rank },
  data() {
    return {
      showRocket: false,
      timeoutId: null,
      showRank: false,
      totalLikeNum: 0,
      hasLike: false,
    }
  },
  beforeDestroy() {
    this.timeoutId && clearTimeout(this.timeoutId)
  },
  mounted() {
    /* eslint-disable */
    socialShare('.share-items', {
      sites: ['weibo', 'wechat'],
      url: window.location.href,
    })
    /* eslint-enable */

  },
  watch: {
    productInfo: function (value) {
      if (value && value.uuid) {
        let totalLike = this.$getItem('_totalLike') || this.$allData.totalLike || {}
        this.totalLikeNum = totalLike[value.uuid] || 0
        let likedObj = this.$getItem('_hasLike') || {}
        if (likedObj[value.uuid]) {
          this.hasLike = true
        }
      }
    }
  },
  methods: {
    openRank() {
      this.showRank = true
    },
    closeRank() {
      this.showRank = false
    },
    clickLike() {
      if (this.hasLike) {
        alert('您已经为他点过赞')
        return false
      } else {
        this.hasLike = true
        this.totalLikeNum += 1
        this.showRocket = true
        this.timeoutId = setTimeout(() => {
          this.showRocket = false
        }, 1000)
        let likedObj = this.$getItem('_hasLike') || {}
        likedObj[this.productInfo.uuid] = true
        this.$setItem('_hasLike', likedObj)
        let likeUrl = 'https://thumbsup-qbh-java-igdpvltehu.cn-shanghai.fcapp.run/show/addPraiseNew'
        axios.post(likeUrl, { suuid: this.productInfo.uuid, visitType: 'praise', userId: 'A000' }).then((response) => {
          if (response.data.status === 'success') {
            // console.log('ok')
            // http://41u7m87222.imdo.co/show/refreshPraiseNew
            axios.get('https://thumbsup-qbh-java-igdpvltehu.cn-shanghai.fcapp.run/show/refreshPraiseNew').then((response) => {
              if (response.data.status === 'success') {
                //  totalLike = response.data.data;
                //  console.log(totalLike,123)
                this.$setItem('_totalLike', response.data.data)
              }
              // cl.doCmdA()
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.person-info {
  width: 100%;
  height: 100%;
  position: relative;
  border-right: 1px solid #ec6000;
}

.user-icon {
  margin: 6rem auto 3rem;
  width: 24rem;
  height: 24rem;
  line-height: 24rem;
  font-size: 0px;
  text-align: center;
}

.user-icon img {
  max-width: 100%;
  max-height: 100%;
}

.place-info-wrapper {
  min-height: 5.4rem;
  padding-left: 6rem;
}

.place-info-wrapper img {
  vertical-align: top;
  width: 8rem;
  height: 5.4rem;
}

.place-info {
  vertical-align: top;
  font-size: 1.8rem;
  color: #282828;
  text-align: left;
  margin-left: 10px;
  max-width: 20rem;
  display: inline-block;
}

.info-item {
  margin-top: 1rem;
  margin-bottom: 0px;
  padding-left: 6rem;
  font-size: 1.8rem;
  color: #282828;
}

.co-wroker {
  margin-top: 4rem;
  padding-left: 6rem;
}

.co-title {
  width: 90%;
  font-size: 1.8rem;
  border-bottom: 1px solid #ec6000;
}

.co-item {
  height: 10rem;
  line-height: 10rem;
  margin-top: 20px;
}

.co-item img {
  width: 10rem;
  height: 10rem;
}

.co-info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  line-height: 1.5;
  word-break: break-all;
  max-width: 60%;
}

.station-info {
  padding-left: 6rem;
  margin-top: 2rem;
}

.station-num {
  width: 90%;
  font-size: 2.4rem;
  font-weight: bold;
  padding: 1rem 0rem;
  border-bottom: 1px solid #ec6000;
}

.button-group {
  margin-top: 6rem;
  padding-bottom: 10rem;
  padding-left: 6rem;
}

.ranking-wrapper {
  display: inline-block;
  vertical-align: top;
  text-align: center;
  width: 8rem;
  height: 8rem;
  font-size: 1.8rem;
  margin-right: 3rem;
}

.ranking-wrapper p {
  line-height: 1.2;
}

.ranking-wrapper span {
  display: inline-block;
  width: 8rem;
  height: 8rem;
  line-height: 8rem;
  text-align: center;
  background-color: #ec6000;
  border-radius: 50%;
  cursor: pointer;
}

.ranking-wrapper img {
  width: 4.5rem;
  height: 3.6rem;
}

.total-like {
  padding-top: 1rem;
  margin-top: 3.6rem;
  margin-bottom: 2rem;
  color: #ec6000;
  font-size: 2rem;
}

.share-wrapper {
  padding-left: 2rem;
  padding-bottom: 2rem;
}

.rocket-wrapper {
  position: absolute;
  width: 8rem;
  height: 42rem;
  right: -4rem;
  bottom: 20%;
}

.rocket-wrapper img {
  width: 100%;
  height: 100%;
}

.rocket-wrapper-img {
  position: absolute;
  width: 8rem;
  height: 13rem;
  right: -4rem;
  bottom: 20%;
}

.rocket-wrapper-img img {
  width: 100%;
  height: 100%;
}

.in-kr-color {
  color: #ffffff;
}

.m-person-info {
  padding-top: 20px;
}

.m-person-info .user-icon {
  display: inline-block;
  margin: 0px;
  width: 24rem;
  height: 24rem;
}

.m-place-info {
  display: inline-block;
  vertical-align: top;
  padding-top: 20px;
  height: 24rem;
}

.m-place-info .place-info {
  font-size: 12px;
  line-height: 1;
}

.m-place-info .place-info span {
  margin-bottom: 6px;
  display: inline-block;
}

.m-place-info .info-item {
  font-size: 14px;
}

.m-place-info-wrapper {
  height: 8rem;
}

.m-place-info-wrapper img {
  width: 9rem;
  height: 6rem;
}

.m-person-info .co-wroker {
  padding-left: 0px;
}

.m-person-info .co-title {
  font-size: 14px;
  font-weight: 550;
}

.m-person-info .station-info {
  padding-left: 0px;
}

.m-person-info .station-num {
  font-size: 14px;
}

.m-person-info .button-group {
  margin-left: 0px;
  padding-left: 0px;
  margin-top: 20px;
}

.m-person-info .ranking-wrapper {
  display: inline-block;
  vertical-align: top;
  width: 14vw;
  height: 14vw;
  font-size: 12px;
  margin-right: 20px;
}

.m-person-info .ranking-wrapper p {}

.m-person-info .ranking-wrapper span {
  display: inline-block;
  width: 8vw;
  height: 8vw;
  line-height: 8vw;
  text-align: center;
  background-color: #ec6000;
  border-radius: 50%;
  cursor: pointer;
}

.m-person-info .ranking-wrapper img {
  width: 4.5rem;
  height: 3.6rem;
}

.m-person-info .total-like {
  font-size: 14px;
}

.rank-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.6);
}

.rank-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  z-index: 300;
  cursor: pointer;
}

.rank-close img {
  width: 100%;
  height: 100%;
}

.m-person-info .rank-close {
  width: 16px;
  height: 16px;
}
</style>